// export const ServerUrl = "http://web-highcharts-production.op-us-west-2.tfk-ext.similarweb.io/";

export const ServerUrl = "https://export.highcharts.com/";
